module.exports = __webpack_public_path__ + "static/media/upperPeep1.c24332e2.svg";